import { useState } from 'react';
import { Cabine } from '@/mocks/cabines';

interface CabineCardProps {
  cabine: Cabine;
  onSelect: (cabine: Cabine) => void;
}

export default function CabineCard({ cabine, onSelect }: CabineCardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#E8610A]/30 transition-all duration-300 cursor-pointer group"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onSelect(cabine)}
    >
      <div className="relative h-64 overflow-hidden bg-gray-50">
        <img
          src={cabine.image}
          alt={cabine.name}
          className={`w-full h-full object-cover object-top transition-transform duration-700 ${hovered ? 'scale-105' : 'scale-100'}`}
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="bg-white/90 backdrop-blur-sm text-gray-600 text-xs font-medium px-2.5 py-1 rounded-full">
            {cabine.category}
          </span>
          {cabine.badge && (
            <span className="bg-[#E8610A] text-white text-xs font-semibold px-2.5 py-1 rounded-full">
              {cabine.badge}
            </span>
          )}
        </div>
      </div>

      <div className="p-5">
        <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-wider mb-1">{cabine.brand}</p>
        <h3 className="text-gray-900 text-lg font-bold mb-2">{cabine.name}</h3>
        <p className="text-gray-500 text-sm leading-relaxed mb-4 line-clamp-2">{cabine.description}</p>

        <div className="flex flex-wrap gap-1.5 mb-4">
          {cabine.features.slice(0, 3).map((f, i) => (
            <span key={i} className="bg-orange-50 text-[#E8610A] text-xs px-2.5 py-1 rounded-full">
              {f}
            </span>
          ))}
          {cabine.features.length > 3 && (
            <span className="bg-gray-100 text-gray-500 text-xs px-2.5 py-1 rounded-full">
              +{cabine.features.length - 3}
            </span>
          )}
        </div>

        <button
          className="w-full bg-[#E8610A] text-white text-sm font-medium py-2.5 rounded-lg hover:bg-[#C4500A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          onClick={(e) => { e.stopPropagation(); onSelect(cabine); }}
        >
          Ver detalhes
        </button>
      </div>
    </div>
  );
}
